import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

import MuiPageWrapper from '@/@mui/MuiPageWrapper';
import { XCircleIcon } from '@/assets/icons/XCircleIcon';
import { PublicRoutes } from '@/config/routes';

const RentCancelPage: React.FC = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push(PublicRoutes.home);
  };

  const handleTryAgain = () => {
    // Go back to previous page
    history.goBack();
  };

  return (
    <MuiPageWrapper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 600,
            width: '100%',
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Stack spacing={3} alignItems="center">
            <XCircleIcon sx={{ fontSize: 60, color: 'error.main' }} />
            <Typography variant="h4">Payment Cancelled</Typography>
            <Typography variant="body1">
              Your rent payment process was cancelled. No charges have been made.
            </Typography>

            <Alert severity="info" sx={{ width: '100%' }}>
              If you need assistance with your payment, please contact your property manager.
            </Alert>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button variant="outlined" color="primary" size="large" onClick={handleGoHome}>
                Go to Homepage
              </Button>
              <Button variant="contained" color="primary" size="large" onClick={handleTryAgain}>
                Try Again
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </MuiPageWrapper>
  );
};

export default RentCancelPage;
